import { History } from "history";
import { ButtonVariant } from "@zanichelli/albe-web-components";
import { ZButton, ZInput } from "@zanichelli/albe-web-components/react";
import i18next from "i18next";
import React from "react";
import { goToPage } from "../../../utils/tools";
import Content from "../Content";
import { Wrap } from "./styles";

type Props = {
  history: History;
  email?: string;
  readonly?: boolean;
  hiddenBtn?: boolean;
  hiddenText?: boolean;
};

const InputMail: React.FC<Props> = ({
  history,
  email,
  readonly,
  hiddenBtn,
  hiddenText,
}) => {
  const renderButton = () => {
    if (hiddenBtn) return null;

    return (
      <ZButton
        variant={ButtonVariant.TERTIARY}
        onClick={() => goToPage("/home", history)}
      >
        {i18next.t("newwotd.checkboxes.input.button")}
      </ZButton>
    );
  };

  const renderText = () => {
    if (hiddenText) return null;

    return <Content>{i18next.t("newwotd.checkboxes.input.title")}</Content>;
  };

  return (
    <Wrap>
      {renderText()}
      <div className="input">
        <ZInput
          label={i18next.t("newwotd.checkboxes.input.label")}
          value={email}
          readonly={readonly}
          message={false}
        />
        {renderButton()}
      </div>
    </Wrap>
  );
};

export default InputMail;
